/* CSV writing and header matching.
   ===============================

   Exports go out of the app entirely and land in someone's Downloads folder,
   usually to be opened in Excel. These are small functions with specific
   opinions about that.
*/

/* Quote only when necessary, and double any quote inside. A client note
   containing a comma is the common case; one containing a newline is rarer and
   worse, because an unquoted newline silently splits one record into two. */
export function csvEscape(v) {
  if (v == null) return '';
  const s = String(v);
  if (/[",\n\r]/.test(s)) return '"' + s.replace(/"/g, '""') + '"';
  return s;
}

/* CRLF line endings and a leading UTF-8 BOM, both for Excel: without the BOM
   it opens accented names as mojibake, and without CRLF some versions treat
   the whole file as one row. */
export function buildCSV(headers, rows) {
  const lines = [headers.map(csvEscape).join(',')];
  for (const r of rows) lines.push(r.map(csvEscape).join(','));
  return '﻿' + lines.join('\r\n');
}

/* Find a column by any of several accepted names, in order of preference.
   Headers are expected already lowercased by the caller. Returns -1 when
   absent, which callers use to mean "this column is optional". */
export function findHeader(headers, ...candidates) {
  for (const c of candidates) {
    const i = headers.findIndex(h => h === c.toLowerCase());
    if (i >= 0) return i;
  }
  return -1;
}

/* What people actually type in a yes/no column of a spreadsheet. */
export function csvTruthy(s) {
  if (s == null) return false;
  return /^(y|yes|true|1|x|✓|new)$/i.test(String(s).trim());
}
